
import Vue, { PropType } from 'vue';

// Types
import { CandidateJobBuilderChangeEvent, commonProps, setupBuilder } from '~/utils/candidate';
import { CandidateJobBuilder } from '~/utils/candidate/CandidateJobBuilder';
import CandidateService from '~/services/CandidateService';
import { ImportSection } from '~/services/types/import';

// Components
import WorkExperienceForm from '../forms/WorkExperienceForm.vue';
import ProfileModal from './ProfileModal.vue';
import ImportBox from '~/components/profile/components/ImportBox.vue';

export default Vue.extend({
    name: 'WorkExperienceModal',
    components: { ProfileModal, WorkExperienceForm, ImportBox },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        ...commonProps(),

        importSection: {
            type: Object as PropType<ImportSection | undefined>,
            required: false,
            default: undefined,
        },
    },
    data() {
        return {
            builder: null as CandidateJobBuilder | null,
            service: new CandidateService(),

            isLoading: false,
            isFormValid: true,
            hasUnsavedChanges: false,
        };
    },
    computed: {
        saveDisabled(): boolean {
            return !this.hasUnsavedChanges || !this.isFormValid;
        },
    },
    methods: {
        handleBuilderChange(evt: CandidateJobBuilderChangeEvent) {
            this.hasUnsavedChanges = !evt.empty;
        },
        handleSave() {
            if (!this.builder || this.builder.isEmpty()) return;
            const request = this.builder.buildRequest();
            this.isLoading = true;
            this.service
                .updateCandidateProfile(request)
                .then(() => {
                    this.isLoading = false;
                    this.$emit('close');
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
    },
    watch: {
        show: {
            immediate: true,
            handler(value: boolean) {
                if (value) {
                    const builder = setupBuilder.apply(this);
                    builder.on('change', this.handleBuilderChange);
                } else {
                    this.builder?.off('change', this.handleBuilderChange);
                    this.builder?.reset();
                }
            },
        },
    },
});
